export type AutoDispatchOverrideState = {
  overrideRowCount: number;
  hasOverrideUnassigned: boolean;
  hasQueuedOverrideChange: boolean;
};

export function shouldResetOverrideAfterServerRefresh({
  overrideRowCount,
  hasOverrideUnassigned,
  hasQueuedOverrideChange,
}: AutoDispatchOverrideState): boolean {
  return overrideRowCount === 0 && !hasOverrideUnassigned && !hasQueuedOverrideChange;
}

export function shouldClearOverrideAfterPlanningResult(hasQueuedOverrideChange: boolean): boolean {
  return !hasQueuedOverrideChange;
}
